import { Component, OnInit, Injectable, ViewChild, Input } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { detailExpand, rowsAnimation } from 'src/app/animations/template.animations';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RoleMasterApiService } from 'src/app/services/domain_code/role-master-api.service';
import { MenuPermission } from 'src/app/models/menu-permission';
import { ThemePalette } from '@angular/material/core';

/**
 * Node for to-do item
 */
export class TodoItemNode {
  children!: TodoItemNode[];
  item!: string;
}

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  item!: string;
  level!: number;
  expandable!: boolean;
}

/**
 * The Json object for to-do list data.
 */
const TREE_DATA = {
  Accounts: ['Charges Master', 'Ex Rate', 'Freight Certificate'],
  Administrator: ['New User Group', 'Outward Register', 'New User Details'],
  Masters: ['Container Master', 'Depot Master', 'Region Master', 'User Master', 'Department Masgter', 'Role Master'],

};

/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<TodoItemNode[]>([]);

  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }

  constructor() {
    // this.initialize();
  }

  initialize() {
    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    //     file node as children.
    // const data = this.buildFileTree(dataSource1, 0);
    const data = this.buildFileTree(TREE_DATA, 0);

    // Notify the change.
    this.dataChange.next(data);
    console.log("Initialize Data", data)
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `TodoItemNode`.
   */
  buildFileTree(obj: { [key: string]: any }, level: number): TodoItemNode[] {
    return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TodoItemNode();
      node.item = key;

      if (value != null) {
        if (typeof value === 'object') {
          node.children = this.buildFileTree(value, level + 1);
        } else {
          node.item = value;
        }
      }

      return accumulator.concat(node);
    }, []);
  }

  /** Add an item to to-do list */
  insertItem(parent: TodoItemNode, name: string) {
    if (parent.children) {
      parent.children.push({ item: name } as TodoItemNode);
      this.dataChange.next(this.data);
    }
  }

  updateItem(node: TodoItemNode, name: string) {
    node.item = name;
    this.dataChange.next(this.data);
  }
}

/**
 * @title Tree with checkboxes
 */
export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}
@Component({
  selector: 'access-select',
  templateUrl: './access-select.component.html',
  styleUrls: ['./access-select.component.scss'],
  providers: [ChecklistDatabase],
  animations: [detailExpand, rowsAnimation],
})
export class AccessSelectComponent implements OnInit {

  errorObj: any = {};
  dit: boolean = true;
  selectedRow: Element | null = null;

  @ViewChild('Save') button: any;
  @Input() tableID!: string;
  @Input() dataSource1: any;
  dataChange = new BehaviorSubject<TodoItemNode[]>([]);

  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }

  searchCtrl = new FormControl();
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: TodoItemFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl: FlatTreeControl<TodoItemFlatNode>;

  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;

  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  checklistSelection1 = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  checklistSelection2 = new SelectionModel<TodoItemFlatNode>(true /* multiple */);

  constructor(private _database: ChecklistDatabase, public dialog: MatDialog,
    private _snackBar: MatSnackBar, private roleService: RoleMasterApiService) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren,
    );
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    _database.dataChange.subscribe(data => {
      this.dataSource.data = data;
    });
  }

  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.item === '';

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.item === node.item ? existingNode : new TodoItemFlatNode();
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.expandable = !!node.children?.length;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };



  shown(q,) {
    console.log(q)
  }
  //floating save icon
  move = (e: any) => {
    // console.log(e);
    this.button._elementRef.nativeElement.style.top = e.layerY - 280 + "px";
    // console.log(this.button._elementRef.nativeElement.style.top);
  }

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {  //checklist0
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection.isSelected(child);
      });
    return descAllSelected;
  }
  descendantsAllSelected1(node: TodoItemFlatNode): boolean {  //checklist1
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection1.isSelected(child);
      });
    return descAllSelected;
  }
  descendantsAllSelected2(node: TodoItemFlatNode): boolean {  //checklist2
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection2.isSelected(child);
      });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean { //checklist
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }
  descendantsPartiallySelected1(node: TodoItemFlatNode): boolean { //checklist1
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection1.isSelected(child));
    return result && !this.descendantsAllSelected1(node);
  }
  descendantsPartiallySelected2(node: TodoItemFlatNode): boolean { //checklist2
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection2.isSelected(child));
    return result && !this.descendantsAllSelected2(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {//checklist
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }
  todoItemSelectionToggle1(node: TodoItemFlatNode): void {//checklist1
    this.checklistSelection1.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection1.isSelected(node)
      ? this.checklistSelection1.select(...descendants)
      : this.checklistSelection1.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelection1.isSelected(child));
    this.checkAllParentsSelection1(node);
  }
  todoItemSelectionToggle2(node: TodoItemFlatNode): void {//checklist2
    this.checklistSelection2.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection2.isSelected(node)
      ? this.checklistSelection2.select(...descendants)
      : this.checklistSelection2.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelection2.isSelected(child));
    this.checkAllParentsSelection2(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }
  todoLeafItemSelectionToggle1(node: TodoItemFlatNode): void {
    this.checklistSelection1.toggle(node);
    this.checkAllParentsSelection(node);
  }
  todoLeafItemSelectionToggle2(node: TodoItemFlatNode): void {
    this.checklistSelection2.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }
  checkAllParentsSelection1(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection1(parent);
      parent = this.getParentNode(parent);
    }
  }
  checkAllParentsSelection2(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection2(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection.isSelected(child);
      });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }
  checkRootNodeSelection1(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection1.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection1.isSelected(child);
      });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection1.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection1.select(node);
    }
  }
  checkRootNodeSelection2(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection2.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection2.isSelected(child);
      });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection2.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection2.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  /** Select the category so we can insert the new item. */
  addNewItem(node: TodoItemFlatNode) {
    const parentNode = this.flatNodeMap.get(node);
    this._database.insertItem(parentNode!, '');
    this.treeControl.expand(node);
  }

  /** Save the node to database */
  saveNode(node: TodoItemFlatNode, itemValue: string) {
    const nestedNode = this.flatNodeMap.get(node);
    this._database.updateItem(nestedNode!, itemValue);
  }
  ngOnInit(): void {
    // document.getElementById("Table")!.addEventListener("mousemove", this.move);
    // this.Initialize();
    console.log("dataSource1", this.dataSource1?.data)

  }

  Initialize() {
    this.dataSource.data = this.dataSource1.data;
    const data = this.buildFileTree(this.dataSource.data, 0);
    this.dataChange.next(data);

    console.log("dataSource1", data)
  }
  buildFileTree(obj: { [key: string]: any }, level: number): TodoItemNode[] {
    return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TodoItemNode();
      node.item = key;

      if (value != null) {
        if (typeof value === 'object') {
          node.children = this.buildFileTree(value, level + 1);
        } else {
          node.item = value;
        }
      }

      return accumulator.concat(node);
    }, []);
  }
  /** Add an item to to-do list */
  insertItem(parent: TodoItemNode, name: string) {
    if (parent.children) {
      parent.children.push({ item: name } as TodoItemNode);
      this.dataChange.next(this.data);
    }
  }

  updateItem(node: TodoItemNode, name: string) {
    node.item = name;
    this.dataChange.next(this.data);
  }




  //This is Updated Code of Role Master//

  changeViewPermission(is_checked, permission, module_idx, menu_idx){
    permission.view_permission = is_checked;

    if(!is_checked){
      permission.add_permission = is_checked;
      permission.edit_permission = is_checked;
    }

    this.savePermission(permission, module_idx, menu_idx)
  }

  changeAddPermission(is_checked, permission, module_idx, menu_idx){
    permission.add_permission = is_checked;

    if(is_checked){
      permission.view_permission = is_checked;
    }

    this.savePermission(permission, module_idx, menu_idx)
  }
  changeEditPermission(is_checked, permission, module_idx, menu_idx){
    permission.edit_permission = is_checked;

    if(is_checked){
      permission.view_permission = is_checked;
    }

    this.savePermission(permission, module_idx, menu_idx)
  }


  savePermission(permission, module_idx, menu_idx) {
    console.log("Permission", permission)
    if (permission.add_permission) {
      permission.view_permission = true;
    }
    if (permission.edit_permission) {
      permission.view_permission = true;
    }
    this._updatemenuPermission(permission.id, permission, module_idx, menu_idx);
    // if ($event.add_permission == false) {
    //   $event.view_permission = false;
    //   $event.edit_permission = false;
    //   this._updatemenuPermission($event.id, $event);
    // }
  }

  _postmenuPermission(data) {
    this.roleService.postMenuPermission(data).subscribe({
      next: response => {
        this._snackBar.open("Menu Permission Created successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        return response;
      },
      error: error => {
        return this.catchError(error);
      }
    });
  }

  _updatemenuPermission(id, data, module_index, menu_index) {
    console.table(data);
    this.roleService.updateMenuPermission(id, data).subscribe({
      next: response => {
        this._snackBar.open("Menu Permission Updated successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        // this.closeDD();

        this.dataSource1.modules[module_index].menus[menu_index].permissions = response;
        this.dataSource1.modules[module_index].menus[menu_index].permissions.menu = this.dataSource1.modules[module_index].menus[menu_index].permissions.menu.id;
        this.dataSource1.modules[module_index].menus[menu_index].permissions.role = this.dataSource1.modules[module_index].menus[menu_index].permissions.role.id;
        this.dataSource1.modules = [...this.dataSource1.modules];

        return response;
      },
      error: error => {
        return this.catchError(error);
      }
    });
  }

  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      return error;
    }
  }
  setAddPermissionForModule(checked, index) {
    for (let menu_idx = 0; menu_idx < this.dataSource1.modules[index].menus.length; menu_idx++) {
      for (let menu_idx = 0; menu_idx < this.dataSource1.modules[index].menus.length; menu_idx++) {

        let permission = this.dataSource1.modules[index].menus[menu_idx].permissions;
  
        this.changeAddPermission(checked, permission, index, menu_idx);
      }

    }

  }

  setViewPermissionForModule(checked, index) {
    for (let menu_idx = 0; menu_idx < this.dataSource1.modules[index].menus.length; menu_idx++) {

      let permission = this.dataSource1.modules[index].menus[menu_idx].permissions;

      this.changeViewPermission(checked, permission, index, menu_idx);
    }
  }
  setUpdatePermissionForModule(checked, index) {
    for (let menu_idx = 0; menu_idx < this.dataSource1.modules[index].menus.length; menu_idx++) {

      let permission = this.dataSource1.modules[index].menus[menu_idx].permissions;

      this.changeEditPermission(checked, permission, index, menu_idx);
    }
    // this.dataSource1.modules[index].is_selected3 = checked;
    // this.dataSource1.modules[index] = {...this.dataSource1.modules[index]}
  }

  isEveryItemInModuleSelected(index, key) {
    return this.dataSource1.modules[index].menus.every(item => {
      if (!item.permissions[key]) {
      }
      return item.permissions[key]
    })
  }

  isAnyItemInModuleSelected(index, key) {
    let full_length = this.dataSource1.modules[index].menus.length;

    let filtered_length = this.dataSource1.modules[index].menus.filter(item => {
      if (!item.permissions[key]) {
      }
      return item.permissions[key]
    }).length

    return filtered_length > 0 && filtered_length < full_length;
  }
}
